import StepsRuntime from '../steps-runtime';

/**
 * 给一个已存在的块设置 StepsRuntime 引擎用的 blockId
 * @param {string} originId - Blockly 原有的 id
 *  * @param {string} newId - 设置的 id
 * @returns {promise} Promise
 */
export default function setBlockId (originId, newId) {
    return new Promise(resolve => {
        const find = document.querySelector(`[data-id="${originId}"]`);
        if (find) {
            stepsRuntime.setBlockId(newId, originId);
        } else {
            console.error(`没有找到 data-id 为 ${originId} 的元素`);
        }
        resolve(true);
    });
}
